export enum UserRole {
  ClinicAdmin = 'clinic-admin',
  ClinicUser = 'clinic-user',
  GcClinicAdmin = 'gc-clinic-admin',
  GcClinicUser = 'gc-clinic-user',
  OrderingPhysician = 'ordering-physician',
  ArteraCustomerSuccess = 'artera-customer-success',
  ArteraSales = 'artera-sales',
  PostRpEnabled = 'post-rp-enabled',
  LabTech = 'lab-tech',
}
